import React, { ReactNode } from 'react';
import { useShowContextRequired } from '../Show';

export function Cell<Type = any>(
  props: {
    label: string | ReactNode,
    weight?: number,
    children: ((item: Type) => ReactNode) | ReactNode,
    sortName?: string,
    isNoWrap?: boolean,
    isCentered?: boolean
  },
) {
  const { children } = props;

  const showContext = useShowContextRequired<Type>();

  if (typeof children === 'function') {
    return <>{children(showContext.data!)}</>;
  } else {
    return <>{children}</>;
  }
}
